export { ContentShadow } from './ContentShadow'
export type {
  ContentShadowProps,
  ContentShadowTabsProps,
  ContentShadowTabsObject,
} from './types'
